var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMegaphoneBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.703,
    height: 23.465,
    viewBox: "0 0 20.703 23.465",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#579ffb;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.526 0.188)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M227.662,13.655,218.511,4.5a1.375,1.375,0,1,0-1.946,1.945l9.153,9.152a1.375,1.375,0,1,0,1.944-1.944Z",
    transform: "translate(-216.163 -4.1)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.92 3.8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M140.822,82.9l-.069.345a14.778,14.778,0,0,1-3.259,6.6l4.979,4.979a14.729,14.729,0,0,1,6.57-3.291l.346-.069Z",
    transform: "translate(-137.494 -82.905)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 11.778)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M34.143,256.989l-3.4,3.4a2.062,2.062,0,0,0,0,2.917l1.944,1.944a2.062,2.062,0,0,0,2.917,0l3.4-3.4Zm.486,5.347a.687.687,0,0,1-.972-.972l.972-.972a.687.687,0,1,1,.972.972Z",
    transform: "translate(-30.136 -256.989)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.41 15.861)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M196.142,350.621l.935-.935a2.061,2.061,0,0,0,0-2.916l-.695-.7a13.017,13.017,0,0,0-1.107.837l.83.831a.686.686,0,0,1,0,.971l-.951.951-1.4-1.354-1.944,1.944,3.119,3.022a1.375,1.375,0,0,0,1.943-1.946Z",
    transform: "translate(-191.813 -346.075)"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.828)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M332.551,0a.687.687,0,0,0-.687.687V2.062a.687.687,0,1,0,1.375,0V.687A.687.687,0,0,0,332.551,0Z",
    transform: "translate(-331.864)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.953 5.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M423.926,120h-1.375a.687.687,0,0,0,0,1.375h1.375a.687.687,0,1,0,0-1.375Z",
    transform: "translate(-421.864 -120)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.578 1.375)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M394.412,30.2a.687.687,0,0,0-.972,0l-1.375,1.375a.687.687,0,1,0,.972.972l1.375-1.375A.687.687,0,0,0,394.412,30.2Z",
    transform: "translate(-391.864 -30)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMegaphoneBlue);
export default __webpack_public_path__ + "static/media/megaphone_blue.bf364f58d0c39f7053b48a4d096482aa.svg";
export { ForwardRef as ReactComponent };